import { StateUtils } from '@spartacus/core';
import { OrderCardPage } from '../../../model';
import { UserActions } from '../actions';
import { OrderCardsActionTypes } from '../actions/order-cards.action';

export const initialState: any = {
  lastUpdateTime: undefined,
  results: [],
};

export function reducer<T>(state: T = initialState, action: UserActions.OrderCardsActions | StateUtils.LoaderAction): T {
  switch (action.type) {
    case OrderCardsActionTypes.SearchOrderCardsSuccess: {
      const _action = <UserActions.SearchOrderCardsSuccess>action;
      const payload: OrderCardPage = _action.payload.searchResult;
      const results = payload.results.map((r) => r.code);

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    case OrderCardsActionTypes.SearchOrderCardsFail: {
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
      };
    }
  }

  return state;
}
